/* global window */
import React, { PureComponent } from "react";
import Link from "gatsby-link";
import cx from "classnames";
import Icon from "./Icon";

class Header extends PureComponent {
  constructor(props) {
    super(props);

    this.handleToggleNav = this.handleToggleNav.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      isOpen: false,
      isScrolled: false
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componetWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleToggleNav() {
    if (this.state.isOpen) {
      this.setState({
        isOpen: false
      });
    } else {
      this.setState({
        isOpen: true
      });
    }
  }

  handleScroll() {
    if (window.scrollY > 100 || window.pageYOffset > 100) {
      this.setState({
        isScrolled: true
      });
    } else {
      this.setState({
        isScrolled: false
      });
    }
  }

  render() {
    const location = this.props;
    const home = location.location.length === 1;

    const checkLocation = l => {
      const pattr1 = new RegExp("contact-us");
      const pattr2 = new RegExp("projects");

      const res = pattr1.test(l);

      if (res === false) {
        return pattr2.test(l);
      }
      return res;
    };

    const colorMe = checkLocation(location.location);

    return (
      <header
        className={cx(
          "fixed w-100 flex justify-between pv3 ph2 ph3-m ph5-l z-1 items-end",
          { "bg-white ease": this.state.isScrolled && !home },
          { "bg-white": colorMe }
        )}
      >
        <Link className="pointer" to="/">
          <Icon
            name="white"
            className={cx(
              "flex",
              { "fill-red-dark": this.state.isScrolled && !home },
              { "fill-red-dark": colorMe },
              { "fill-white": !this.state.isScrolled && !colorMe }
            )}
            height={24}
            width={188}
          />
        </Link>

        {/* mobile nav */}
        <a
          className="list pa0 ma0 dn-l pointer"
          onClick={() => {
            this.handleToggleNav();
          }}
        >
          <Icon
            name="dropdown-bars"
            className={cx(
              { "fill-red-dark": this.state.isScrolled && !home },
              { "fill-red-dark": colorMe },
              { "fill-white": !this.state.isScrolled && !colorMe }
            )}
            height={16}
            width={16}
          />
        </a>
        <nav
          className={cx(
            "w-100 vh-100 bg-red-dark absolute top-0 left-0 items-center justify-center",
            { dn: !this.state.isOpen },
            { flex: this.state.isOpen }
          )}
          style={{
            backgroundImage: `url(${require("../images/background-shape-mobile-white.png")})`,
            backgroundSize: "cover"
          }}
        >
          <div
            className="absolute top-0 right-0 pt2 pr2 pointer"
            aria-label="Close"
            onClick={() => {
              this.handleToggleNav();
            }}
          >
            <Icon name="close-icon" />
          </div>
          <ul
            className="ttu white b list pa0 ma0 flex flex-column items-center"
            onClick={() => {
              this.handleToggleNav();
            }}
          >
            <li>
              <Link className="white ls-m db pv3" to="/projects/">
                Projects
              </Link>
            </li>
            <li>
              <Link className="white ls-m db pv3" to="/about/">
                About
              </Link>
            </li>
            <li>
              <Link className="white ls-m db pv3" to="/contact-us/">
                Contact Us
              </Link>
            </li>
          </ul>
        </nav>

        {/* desktop nav */}
        <nav className="dn flex-l items-end">
          <ul
            className={cx(
              "f-xxs ttu b list flex pa0 ma0",
              { "red-dark": this.state.isScrolled && !home },
              { white: !this.state.isScrolled },
              { "red-dark": colorMe },
              { white: !colorMe }
            )}
          >
            <li>
              <Link className="pr3 ls-m" to="/">
                Home
              </Link>
            </li>
            <li>
              <Link className="ph3 ls-m" to="/projects/">
                Projects
              </Link>
            </li>
            <li>
              <Link className="ph3 ls-m" to="/about/">
                About
              </Link>
            </li>
            <li>
              <Link className="pl3 ls-m" to="/contact-us/">
                Contact Us
              </Link>
            </li>
          </ul>
        </nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js